import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class AssuranceService {

    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/assurance/get'), callback, queryParams);
    getPointAssurance = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/assurance/point-assurance'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/assurance/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/assurance/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/assurance/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/assurance/delete/${id}`), callback);

}